import React from 'react';
import { bool, func, string } from 'prop-types';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import Button from '../../shared/Button';

import * as styles from './styles/styles.module.scss';

const TextEditItem = ({
  canEdit,
  data,
  placeholderText,
  isEditShown,
  submitInProgress,
  submitFailed,
  hide,
  handleSubmit,
  dataSource,
  descriptionValue,
  show,
  handleEditDescription
}) => {
  let itemText = '';
  let newPlaceholderText = StringConstantsMixin.strings.TRACK_DETAIL.NO_DESCRIPTION_ADDED;
  if (placeholderText) {
    newPlaceholderText = placeholderText;
  } else if (canEdit) {
    newPlaceholderText = StringConstantsMixin.strings.TRACK_DETAIL.TELL_WHAT_YOU_DID;
  }

  if (isEditShown) {
    // Edit mode
    let statusText = null;
    let textAreaDisabled = false;
    if (submitInProgress) {
      statusText = StringConstantsMixin.strings.SAVING;
      textAreaDisabled = true;
    } else if (submitFailed) {
      statusText = StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_SAVE_UPDATE;
    } else {
      statusText = StringConstantsMixin.strings.SAVE;
    }

    const buttonContainer = (
      <div className={styles.editButtons}>
        <Button variant="flat" onClick={hide} disabled={submitInProgress}>
          {StringConstantsMixin.strings.CANCEL}
        </Button>
        |
        <Button variant="flat" onClick={handleSubmit} disabled={submitInProgress}>
          {statusText}
        </Button>
      </div>
    );
    const textarea = (
      <textarea
        className={styles.textArea}
        disabled={textAreaDisabled}
        placeholder={newPlaceholderText}
        itemProp="description"
        value={descriptionValue}
        onChange={handleEditDescription}
      />
    );
    itemText = (
      <div className={styles.tabContent}>
        {textarea}
        {buttonContainer}
      </div>
    );
  } else {
    // Non-Edit Mode
    let innerText = placeholderText;
    if (dataSource) {
      innerText = dataSource;
    } else if (data) {
      innerText = data;
    }

    if (canEdit) {
      // User has ability to edit
      const linkText = StringConstantsMixin.strings.ADD;
      itemText = (
        <div className={styles.emptyTabContent}>
          <span className={styles.innerText}>{innerText}</span>
          <div className={styles.emptyTabBtn}>
            <Button variant="flat" onClick={show}>
              {linkText}
            </Button>
          </div>
        </div>
      );
    } else {
      // Default
      itemText = (
        <div className={styles.tabContent}>
          <span className={styles.innerText}>{innerText}</span>
        </div>
      );
    }
  }
  return itemText;
};

const DescriptionSection = ({
  placeholderText,
  data,
  canEdit,
  dataSource,
  handleSubmit,
  isEditShown,
  submitInProgress,
  handleEditDescription,
  submitFailed,
  hide,
  show,
  descriptionValue
}) => {
  if ((!data || !data.length) && !canEdit) {
    placeholderText = '';
  }
  return (
    <div className={styles.descriptionSection}>
      <TextEditItem
        data={data}
        dataSource={dataSource}
        canEdit={canEdit}
        placeholderText={placeholderText}
        handleEditDescription={handleEditDescription}
        handleSubmit={handleSubmit}
        isEditShown={isEditShown}
        submitInProgress={submitInProgress}
        submitFailed={submitFailed}
        hide={hide}
        descriptionValue={descriptionValue}
        show={show}
      />
    </div>
  );
};

TextEditItem.propTypes = {
  canEdit: bool,
  data: string,
  placeholderText: string,
  isEditShown: bool,
  submitInProgress: bool,
  submitFailed: bool,
  hide: func,
  handleSubmit: func,
  dataSource: string,
  descriptionValue: string,
  show: func,
  handleEditDescription: func
};

TextEditItem.defaultProps = {
  canEdit: false,
  data: '',
  placeholderText: '',
  isEditShown: false,
  submitInProgress: false,
  submitFailed: false,
  hide: () => {},
  handleSubmit: () => {},
  dataSource: '',
  descriptionValue: '',
  show: () => {},
  handleEditDescription: () => {}
};

export default DescriptionSection;
